import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;

    span {
        font-size: 32px;
        font-weight: 900;
        font-size: clamp(20px, 6vw, 32px);
        color: ${theme.textDark};
    }

    label {
        font-size: 11px;
        font-weight: 400;
        color: ${theme.textDark};
    }
`;

export { Container };